import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  transcript: {
    lineHeight: '1.6',
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '17px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
  },
  image: {
    width: '60%',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '75%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
  playButton: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
    padding: '20px',
    fontSize: '30px',
    cursor: 'pointer',
    background: '#fff',
    },
}));

export { useStyles };
